import { useState } from "react";
import { Button } from "@mui/material";
import AuthPopup from "./AuthPopup";

export const LogInButton = ({ variant = "outlined" }) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  return (
    <>
      <Button
        onClick={() => setIsPopupOpen(true)}
        variant={variant}
        color="primary"
      >
        Log In
      </Button>

      <AuthPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
    </>
  );
};
